'use client';

import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/layout/Layout.module.scss';
import { useKind } from '@/app/cc/KindContext';

export default function CompanyInfo() {
  const kind = useKind();

  return kind === 'LEE_APP' ? null : (
    <div className={styles.infoItem}>
      <Text as="p" category="caption" variant="sb1">
        프롭티어(주) 대표자 서동록
      </Text>
      <div>
        <Text as="p" category="body" variant="r3">
          서울특별시 서초구 방배로 107, 디엠타워3관
        </Text>
        <Text as="p" category="body" variant="r3">
          통신판매신고번호 : 제 2019-서울서초-0765
        </Text>
        <Text as="p" category="body" variant="r3">
          사업자번호 : 214-87-09557 | 고객센터 : 1800-6950
        </Text>
      </div>
    </div>
  );
}
